const ActivitiesSite = require("@/modules/activities/components/ActivitiesSite.vue")
  .default;
const ActivityDetailSite = require("@/modules/activities/components/ActivityDetailSite.vue")
  .default;
const ActivitiesManageSite = require("@/modules/activities/components/ActivitiesManageSite.vue")
  .default;
const ActivitiesCreateSite = require("@/modules/activities/components/ActivitiesCreateSite.vue")
  .default;
const DayActivitiesSite = require("@/modules/activities/components/DayActivitiesSite.vue")
  .default;

const ActivityRoutes = [
  {
    name: "Activitys",
    path: "/activities/",
    component: ActivitiesSite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Activity Detail",
    path: "/activity/:id",
    components: { default: ActivityDetailSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Manage Activities",
    path: "/manage-activities",
    components: { default: ActivitiesManageSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Create Activity",
    path: "/create-activity",
    components: { default: ActivitiesCreateSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Day Activities",
    path: "/activities-day/:date",
    components: { default: DayActivitiesSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Todays Day Activities",
    path: "/activities-day/",
    components: { default: DayActivitiesSite },
    meta: {
      requiresAuth: true,
    },
  },
];

const ActivitySettingsRoutes = [];

const ActivityBaseDataRoutes = [];

export { ActivityRoutes, ActivitySettingsRoutes, ActivityBaseDataRoutes };
